@if (state$ | async; as state) {
  @if (state.status !== 'idle') {
    <div
      class="scanner-panel"
      [class.scanner-panel--consume]="state.mode === 'consume'"
      [class.scanner-panel--open]="state.mode === 'open'"
      [class.scanner-panel--info]="state.mode === 'info'"
      [class.scanner-panel--consume-open]="state.mode === 'consume-open'">
      <div class="scanner-panel__active">
        <div class="scanner-panel__header">
          <span class="scanner-panel__mode-chip">{{ modeEmoji(state.mode) }} {{ modeLabel(state.mode) }}</span>
          <div class="scanner-panel__timer" [class.scanner-panel__timer--warning]="state.secondsRemaining <= 10">
            <div class="scanner-panel__timer-bar">
              <div class="scanner-panel__timer-fill" [style.width.%]="(state.secondsRemaining / 60) * 100"></div>
            </div>
            <span>{{ state.secondsRemaining }}s</span>
          </div>
        </div>

        @if (state.lastScan) {
          @if (isActionResult(state.lastScan)) {
            <div
              class="scanner-panel__last-scan scanner-panel__last-scan--action"
              [class.scanner-panel__last-scan--undone]="state.lastScan.undone">
              <span>
                @if (state.lastScan.undone) {
                  ↩
                } @else {
                  ✓
                }
                {{ state.lastScan.productName }}
                {{ state.lastScan.undone ? 'undone' : state.lastScan.mode + 'd' }}
                {{ state.lastScan.amount }} {{ state.lastScan.unitName }}
              </span>
              @if (!state.lastScan.undone) {
                <span class="scanner-panel__undo-hint">scan SKYE_UNDO to undo</span>
              }
            </div>
          }
          @if (isInfoResult(state.lastScan)) {
            <div class="scanner-panel__last-scan scanner-panel__last-scan--info">
              <strong>{{ state.lastScan.productName }}</strong>
              <span>
                {{ state.lastScan.stockAmount }} {{ state.lastScan.unitName }} in stock ({{
                  state.lastScan.openedAmount
                }}
                opened)
              </span>
              @if (state.lastScan.lastConsumedAt) {
                <span>🥄 last consumed {{ state.lastScan.lastConsumedAt | date: 'd MMM yyyy' }}</span>
              }
              @if (state.lastScan.lastPurchasedAt) {
                <span>🛒 last bought {{ state.lastScan.lastPurchasedAt | date: 'd MMM yyyy' }}</span>
              }
            </div>
          }
          @if (isConsumeOpenResult(state.lastScan)) {
            <div
              class="scanner-panel__last-scan scanner-panel__last-scan--consume-open"
              [class.scanner-panel__last-scan--undone]="state.lastScan.undone">
              <span>
                @if (state.lastScan.undone) {
                  ↩
                } @else {
                  ✓
                }
                {{ state.lastScan.productName }} — consumed {{ state.lastScan.consumeAmount }}
                {{ state.lastScan.unitName }}, opened {{ state.lastScan.openAmount }} new
              </span>
              @if (!state.lastScan.undone) {
                <span class="scanner-panel__undo-hint">scan SKYE_UNDO to undo consume</span>
              }
            </div>
          }
        }

        @if (state.recentScans.length > 1) {
          <div class="scanner-panel__history">
            @for (scan of state.recentScans.slice(1, 4); track scan.timestamp) {
              <span class="scanner-panel__history-item">
                @if (isActionResult(scan)) {
                  {{ scan.undone ? '↩' : '✓' }} {{ scan.productName }}
                }
                @if (isInfoResult(scan)) {
                  ℹ {{ scan.productName }}
                }
                @if (isConsumeOpenResult(scan)) {
                  {{ scan.undone ? '↩' : '✓' }} {{ scan.productName }} (consume+open)
                }
              </span>
            }
          </div>
        }

        @if (state.secondsRemaining <= 10) {
          <div class="scanner-panel__warning">Closing in {{ state.secondsRemaining }}s — scan anything to reset</div>
        }
      </div>
    </div>
  }
}
